import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const TransportReportingApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "TransportReporting" */ "./TransportReportingApp");
    return { default: namedExport.TransportReportingApp };
});

export const TransportReporting: TeamAppConfig = {
    title: "Transport Reporting V2",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "TransportReporting",
    team: "Transport",
    publicId: "Exchange\\Transport",
    owner: "TSZMFeatureCrew@microsoft.com",
    role: "*",
    tags: [],
    app: TransportReportingApp,
    path: "/TransportReporting"
};
